import styled from 'styled-components';

import { themed } from '@/shared/ui/core';

export const ModalContainer = styled.div`
  .Title {
    color: ${themed('primary.accent')};
    font-size: 1.5rem;
  }

  .component__button {
    font-weight: 500;
    height: 3rem;
  }

  .slick-dots {
    margin-bottom: 0;
  }

  .component__Checkbox {
    h4 {
      color: ${themed('primary.accent')};
      font-size: 1.125rem;
      margin: 0 0 0.25rem;
    }

    p {
      color: ${themed('primary.darkGray')};
      font-size: 0.875rem;
      margin: 0;
    }
  }
`;

export const CheckBoxContainer = styled.li`
  list-style: none;
  margin-top: 0.5rem;

  label {
    font-size: 1rem;
    color: ${themed('primary.accent')};
    align-items: ${({ align }) => align};

    .checkbox__input {
      &:checked ~ .checkbox__IconContainer {
        background-color: ${themed('input.checkbox.background')};
        border-color: ${themed('input.checkbox.background')};

        svg {
          fill: ${themed('input.checkbox.check')};
          width: 1rem;
          height: auto;
        }
      }
    }

    .checkbox__IconContainer {
      width: 1.875rem;
      height: 1.875rem;
      border-color: ${themed('login.color')};
      border-radius: 0.25rem;
      margin-right: 0.625rem;
      margin-bottom: 0.0625rem;
      flex-shrink: 0;
    }
  }
`;

export const CheckboxList = styled.ul`
  margin: 0;
  padding: 0;
  display: grid;
  gap: ${({ gap }) => gap}px;
  grid-template-columns: ${({ columns = 1 }) => `repeat(${columns}, 1fr)`};
`;

export const RangeContainer = styled.div`
  margin: 0 .25rem 3.5rem;
`;

export const ButtonContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 1.5rem 0 1rem;
`;

export const NoPreferenceButtonStyled = styled.a`
  color: ${themed('primary.accent')};
  cursor: pointer;
  display: inline-block;
  font-size: 1.065rem;
  font-weight: bold;
  margin-top: 1.65rem;
  position: relative;
  text-align: center;

  &:after {
    content: "";
    border-bottom: 2px solid ${themed('primary.accent')};
    bottom: -5px;
    left: 0;
    position: absolute;
    width: 100%;
  }
`;
